import RequestService from '../services/request.service';
import { parseGetETAParams } from '../parsers/eta.parser';

export default function getEta(requestId, state) {
  return RequestService.getProviderEtas(requestId, parseGetETAParams(state));
}
